module.exports = "https://www.gc-pro.gnp.com.mx/a01ec9a000d869c7b2b209d096f4a24e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/reembolso-gmm/02.png
// module id = 1048
// module chunks = 0 1